import OutlineButton from "components/Button/OutlineButton";
import { Flex } from "@chakra-ui/react";
import { SiMicrosoftexcel } from "react-icons/si";
import colors from "core/resources/theme/colors";

interface ButtonExportarExcelProps {
  onClick: () => any;
}

function ButtonExportarExcel({ onClick }: ButtonExportarExcelProps) {
  return (
    <OutlineButton
      p={0}
      w="100%"
      justifyContent="start"
      mb={1}
      border="none"
      onClick={onClick}
    >
      <Flex w={"16px"} mr={-1}>
        <SiMicrosoftexcel color={colors.primary} size={34} />
      </Flex>
      Exportar Excel
    </OutlineButton>
  );
}

export default ButtonExportarExcel;
